var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4967_11537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5817 12.6117C10.0683 12.7633 9.46167 12.8333 8.75 12.8333H5.25C4.53833 12.8333 3.93167 12.7633 3.41833 12.6117C3.54667 11.095 5.10417 9.89917 7 9.89917C8.89583 9.89917 10.4533 11.095 10.5817 12.6117Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74996 1.16675H5.24996C2.33329 1.16675 1.16663 2.33341 1.16663 5.25008V8.75008C1.16663 10.9551 1.83163 12.1626 3.41829 12.6117C3.54663 11.0951 5.10413 9.89925 6.99996 9.89925C8.89579 9.89925 10.4533 11.0951 10.5816 12.6117C12.1683 12.1626 12.8333 10.9551 12.8333 8.75008V5.25008C12.8333 2.33341 11.6666 1.16675 8.74996 1.16675ZM6.99996 8.26591C5.84496 8.26591 4.91163 7.32675 4.91163 6.17175C4.91163 5.01675 5.84496 4.08341 6.99996 4.08341C8.15496 4.08341 9.08829 5.01675 9.08829 6.17175C9.08829 7.32675 8.15496 8.26591 6.99996 8.26591Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08829 6.17159C9.08829 7.32659 8.15495 8.26575 6.99995 8.26575C5.84495 8.26575 4.91162 7.32659 4.91162 6.17159C4.91162 5.01659 5.84495 4.08325 6.99995 4.08325C8.15495 4.08325 9.08829 5.01659 9.08829 6.17159Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4967_11537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersquare);
export default __webpack_public_path__ + "static/media/usersquare.7360b3563e30ccdceb6a4ab122b302ed.svg";
export { ForwardRef as ReactComponent };